// Ce qui reste d'un module éteint (D-122) : « les personnes déjà inscrites à un créneau ou un événement le gardent
// jusqu'à sa date ». Sur l'accueil du rôle, une carte sobre (sans lien vers un module éteint, sans relance) : mon
// créneau de bénévole, mon inscription à un événement du club.
import { keptCommitments } from '../lib/modules-api';
import { parseLocalDate } from '../domain/schedule';
import type { Ctx } from './context';
import { html, mount } from './dom';

const day = (d: Date) => d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'short' });

export async function renderKeptCard(el: HTMLElement, ctx: Ctx): Promise<void> {
  if (!ctx.club) return;
  const k = await keptCommitments(ctx.club.id).catch(() => null);
  const rows = [
    ...(k?.slots ?? []).map(s => ({ at: parseLocalDate(s.date), title: `Ton créneau · ${s.label}`, sub: `${day(parseLocalDate(s.date))} · ${s.title}` })),
    ...(k?.events ?? []).map(e => ({ at: new Date(e.starts_at), title: `Ton inscription · ${e.title}`, sub: `${day(new Date(e.starts_at))}${e.location ? ` · ${e.location}` : ''}` })),
  ].sort((a, b) => a.at.getTime() - b.at.getTime()).slice(0, 2);
  if (!rows.length) { mount(el, html``); return; }
  mount(el, html`${rows.map(r => html`
    <section class="card mo-row" data-guide="home-kept"><span class="mi-ico" aria-hidden="true"><span class="ti ti-cal"></span></span>
      <span class="card-main"><strong>${r.title}</strong><span class="muted small">${r.sub} · on compte sur toi</span></span></section>`)}`);
}
